{
  "api_token_create": "Создать токен",
  "api_token_generate_title": "Новый API-токен",
  "api_token_lifetime": "Срок жизни",
  "api_token_lifetime_unlimited": "Без ограничений",
  "api_token_lifetime_custom": "Свой период",
  "api_token_lifetime_days": "Количество дней",
  "api_token_created_title": "Сохраните API-токен",
  "api_token_created_warning": "Токен виден только сейчас",
  "api_token_created_description": "Скопируйте его и сохраните в надёжном месте — позже показать его снова мы не сможем.",
  "api_token_value": "Токен",
  "api_token_copy": "Скопировать токен",
  "api_token_valid_to": "Действителен до {date}",
  "all_docs": "Все документы",
  "esign_requests": "Запросы на подпись",
  "esign_created_by_me": "Созданные мной",
  "esign_envelopes_completed_of": "{completed} из {total} завершено",
  "esign_signed_of": "{signed} из {total} подписано",
  "esign_acknowledged_of": "{signed} из {total} ознакомились",
  "print_generated_with": "Сформировано в %APP_NAME%",
  "esign_evidence_auth_email_otp": "Одноразовый код по email",
  "esign_evidence_ip": "IP-адрес",
  "esign_evidence_timeline": "Хронология событий",
  "esign_evidence_verification": "Проверки",
  "esign_status_pending": "Ожидает",
  "esign_status_signed": "Подписан",
  "esign_status_acknowledged": "Ознакомлен",
  "esign_status_cancelled": "Отменен",
  "esign_cancel_request_submit": "Отменить запрос",
  "esign_cancel_request_confirm_title": "Отменить запрос на подпись?",
  "esign_cancel_request_confirm_text": "Сотрудники, которые ещё не подписали, больше не смогут это сделать. Поставленные подписи сохранятся.",
  "esign_signing_status": "Статус подписания",
  "esign_signing_progress": "Прогресс подписания",
  "esign_status_awaiting_signature": "Ожидает подписи",
  "esign_status_awaiting_acknowledgment": "Ожидает ознакомления",
  "access_data_for_all_employees": "Доступ к данным всех сотрудников",
  "access_data_for_all_employees_description": "Участники с этой ролью имеют доступ к данным всех сотрудников.",
  "access_disabled": "Доступ отключён",
  "account_email": "Электронная почта аккаунта",
  "account_general_security": "Общая безопасность",
  "account_localisation": "Локализация",
  "account_localisation_caption": "Язык, часовой пояс",
  "account_manage_personal_info_description": "Управляйте личной информацией в вашем <profile>профиле</profile>",
  "account_notifications_caption": "Управление уведомлениями %APP_NAME%",
  "account_overview": "Обзор аккаунта",
  "account_recruitment_caption": "Интеграции и расширение",
  "account_security_caption": "Пароль и аутентификация",
  "account_settings": "Настройки аккаунта",
  "account_theme_caption": "Выберите цветовую схему интерфейса",
  "email_provider": "Провайдер электронной почты",
  "email_provider_caption": "Подключите рабочую почту и общайтесь с кандидатами в %APP_NAME%",
  "email_servers_provider_caption": "Любой другой SMTP/IMAP-провайдер",
  "extension_style": "Вид расширения",
  "find_out_more": "Узнать подробнее",
  "add_action": "Добавить действие",
  "add_comment_to_employment": "Добавьте комментарий к смене занятости...",
  "add_comment_to_position": "Добавьте комментарий к смене должности...",
  "add_link": "Добавить ссылку",
  "add_members": "Добавить участников",
  "add_new_teammate": "Новый человек в команде",
  "add_or_search_field": "Добавить или найти поле",
  "additional_compensation": "Дополнительная компенсация",
  "additional_compensation_empty_state_description": "Добавьте бонусы, надбавки и другие выплаты сверх основной зарплаты",
  "additional_compensation_empty_state_title": "Дополнительных выплат пока нет",
  "address": "Адрес",
  "address_line_1": "Адресная строка 1",
  "address_line_2": "Адресная строка 2",
  "all_active_employees": "Все активные сотрудники",
  "all_employees": "Все сотрудники",
  "already_have_an_account": "Уже есть аккаунт?",
  "amount_money": "Сумма",
  "amount_money_gross": "Сумма (до удержаний)",
  "amount_money_net": "Сумма к выплате",
  "anonymous_bug": "Просто какой-то жук",
  "anonymous_cow": "Честная корова",
  "anonymous_dog": "Пёс, который слишком много видел",
  "anonymous_dragon": "Болотный шептун",
  "anonymous_koala": "Коала на беззвучном",
  "anonymous_panda": "Панда в тенях",
  "anonymous_penguin": "Бессонный пингвин",
  "anonymous_shrimp": "Красная креветка",
  "anonymous_squirrel": "Скрытная белка",
  "app_name": "%APP_NAME%",
  "app_update_available_button": "Обновить",
  "app_update_available_description": "Мы выпустили новую версию с последними улучшениями. Пожалуйста, обновите страницу",
  "app_update_available_title": "Доступно обновление",
  "apply_settings_to_another_role": "Применить эти настройки к другой роли",
  "service_user_create": "Создать пользователя",
  "service_user_edit": "Изменить пользователя",
  "service_users": "Сервисные пользователи",
  "service_user_delete_confirm": "Пользователь будет удалён и потеряет доступ к API.",
  "roles_service_users": "Роли сервисных пользователей",
  "roles_service_users_description": "Создавайте роли для сервисных пользователей и применяйте их на основе определенных правил",
  "apply_to_description": "Добавьте одно или несколько правил. Будут выбраны только сотрудники, которые соответствуют всем условиям.",
  "apply_to_employees": "К чьим данным имеют доступ участники?",
  "apply_to_employees_description": "Выберите, какие профили сотрудников доступны для этой роли",
  "assign_department_head_description": "Назначает руководителя отдела для управления отделом, где уволенный сотрудник был руководителем. Если отключено, в этом отделе не будет руководителя",
  "assign_department_head_title": "Назначить руководителя отдела",
  "assign_employees": "Назначить сотрудникам",
  "assign_employees_description": "Все правила объединяются для создания комплексного набора",
  "assign_employees_to_this_role": "Назначить сотрудников на эту роль",
  "assign_service_user": "Назначить сервисным пользователям",
  "assign_service_user_description": "Выберите сервисных пользователей, к которым применяется эта роль.",
  "select_service_users": "Выбрать сервисных пользователей",
  "assign_manager_to_subordinates_description": "Автоматически назначает нового руководителя сотрудникам департамента. Если отключено, руководитель у подчиненных останется прежним",
  "assign_manager_to_subordinates_title": "Назначить нового руководителя подчиненным",
  "assign_position": "Назначить должность",
  "authentication": "Аутентификация",
  "authentication_methods": "Методы аутентификации",
  "two_factor_authentication": "Двухфакторная аутентификация",
  "base_salary_gross": "Оклад (до удержаний)",
  "base_salary_net": "К выплате",
  "birth_date": "Дата рождения",
  "birth_date_visibility_edit": "Видеть и изменять полную дату",
  "birth_date_visibility_view": "Видеть полную дату",
  "birthday": "День рождения",
  "birthday_display": "Отображать дату рождения",
  "birthday_display_caption": "Если выбран параметр «Нет», редактирование отключается, и по умолчанию применяется настройка на уровне организации",
  "birthday_display_full": "Полная",
  "birthday_display_none": "Скрыть",
  "birthday_display_settings": "Настройки отображения дня рождения",
  "birthday_display_settings_permission_edit": "Учитывать и менять настройку",
  "birthday_display_settings_permission_edit_description": "То же, плюс сотрудник может менять настройку в профиле",
  "birthday_display_settings_permission_none": "По настройке организации",
  "birthday_display_settings_permission_none_description": "Используется настройка организации",
  "birthday_display_settings_permission_view": "Учитывать настройку сотрудника",
  "birthday_display_settings_permission_view_description": "Показывает полную дату, только день и месяц или скрывает день рождения по настройке сотрудника",
  "name_display_level": "Уровень видимости имени",
  "name_display_level_full": "Полное имя",
  "name_display_level_full_description": "Имя и фамилия сотрудника отображаются полностью",
  "name_display_level_initial": "Имя и инициал фамилии",
  "name_display_level_initial_description": "Отображаются имя сотрудника и первая буква фамилии",
  "name_display_level_first_only": "Только имя",
  "name_display_level_first_only_description": "Отображается только имя сотрудника",
  "birthday_display_short": "Только день и месяц",
  "calendar_days": "Календарные дни",
  "calendar_holiday_copy_from_description": "Вы уверены, что хотите скопировать все даты с прошлого года? Это действие продублирует все рабочие праздники, нерабочие праздники и компенсационные дни в календарь текущего года",
  "calendar_holiday_date_compensated_description": "Если праздничный выходной совпадает с выходным днем (например, воскресеньем), предоставляется дополнительный выходной в будний день, чтобы сотрудники не потеряли возможность отдыха",
  "calendar_holiday_date_compensated_title": "Перенос выходного дня",
  "calendar_holiday_date_non_working_description": "Это официальные государственные праздники, в которые сотрудники не обязаны работать",
  "calendar_holiday_date_non_working_title": "Нерабочий, выходной",
  "calendar_holiday_date_type": "Тип дня",
  "calendar_holiday_date_working_description": "Эти дни изначально считаются праздничными, но они не дают автоматического выходного. Сотрудники работают, как в обычный рабочий день, если только не оформляют отсутствие",
  "calendar_holiday_date_working_title": "Перенос рабочего дня",
  "calendar_holiday_country_sync_description": "Государственные праздники за текущий и следующий год добавляются автоматически и обновляются каждую неделю. Ваши ручные изменения всегда имеют приоритет — синхронизация их не перезаписывает и не восстанавливает.",
  "calendar_holiday_country_sync_title": "Праздники синхронизируются автоматически",
  "calendar_holiday_edit_title": "Праздник",
  "calendar_holiday_new": "Добавить праздник",
  "calendar_holiday_policy": "Политика праздников",
  "calendar_holidays_empty_state_description": "Календари используются при начислении балансов отсутствий",
  "calendar_holidays_empty_state_title": "Календари не созданы",
  "calendar_holidays_title": "Производственный календарь",
  "calendar_holidays_title_filter_description": "Выберите локации, департаменты и подразделения, к которым будет применяться эта политика. Вы можете указать несколько фильтров",
  "clear_selection": "Сбросить выбор",
  "calendar_holidays_title_filter_title": "К кому применяется эта политика?",
  "calendar_holidays_title_short": "Произв. календарь",
  "change_background": "Изменить фон",
  "change_background_caption": "Загрузить новое фоновое изображение",
  "change_compensation": "Изменить компенсацию",
  "change_compensation_caption": "Обновить оклад и условия оплаты",
  "change_employment": "Изменить занятость",
  "change_employment_caption": "Обновить тип занятости и дату начала",
  "change_position": "Изменить должность",
  "change_position_caption": "Обновить должность, отдел и подчинённость",
  "change_work_details": "Изменить рабочие данные",
  "change_work_details_caption": "Должность, занятость, компенсация, увольнение",
  "channels": "Каналы",
  "check_employee_roles": "Проверьте роли сотрудников",
  "choose_hire_date": "Выберите дату начала работы",
  "choose_when_employee_start": "Выберите, когда сотрудник официально приступает к работе",
  "city": "Город",
  "code_for_connection": "Код для подключения",
  "codes_for_backup": "Коды для восстановления",
  "company_details": "Детали компании",
  "company_details_description": "В настройках организации вы можете заполнить необходимую информацию о вашей компании",
  "compensation": "Компенсация",
  "compensation_change_reason": "Причина изменения зарплаты",
  "compensation_change_reasons": "Причины изменения зарплат",
  "compensation_date": "Дата изменения компенсации",
  "compensation_type": "Тип компенсации",
  "compensation_types": "Типы компенсаций",
  "compensation_rollup_incomplete_description": "В итог не вошли: {lines}",
  "compensation_rollup_unknown_lines": "строки без суммы или курса валюты",
  "compensation_rollup_estimated_description": "Значение приблизительное из-за пересчёта периодов.",
  "compensation_package_lines": "Компоненты компенсации",
  "compensation_line_component": "Компонент",
  "compensation_line_gross": "Сумма до удержаний",
  "compensation_line_net": "Сумма к выплате",
  "compensation_line_currency_separator": "в",
  "compensation_before_change": "До изменения",
  "compensation_after_change": "После изменения",
  "compensation_add_line": "Добавить компенсацию",
  "compensation_totals": "Итоговая компенсация",
  "compensation_gross_rollup": "Сумма до удержаний",
  "compensation_net_official_rollup": "Официальная сумма после удержаний",
  "compensation_net_actual_rollup": "Фактическая сумма после удержаний",
  "compensation_total_cost_rollup": "Полная стоимость для компании",
  "compensation_summary_total_cost": "Полная стоимость для компании",
  "compensation_summary_total_cost_description": "Общие расходы компании на сотрудника, включая взносы работодателя и компенсации вне зарплатной ведомости.",
  "compensation_summary_gross_description": "Компенсация до удержаний без учёта выплат вне зарплатной ведомости.",
  "compensation_summary_net": "К выплате",
  "compensation_summary_net_description": "Сумма, которую получает сотрудник, включая компенсации вне зарплатной ведомости.",
  "compensation_summary_breakdown": "Состав компенсации",
  "compensation_line_change_added": "Добавлено",
  "compensation_line_change_removed": "Удалено",
  "compensation_line_change_changed": "Изменено",
  "compensation_component_kind": "Вид компонента",
  "compensation_component_kind_earning": "Выплата",
  "compensation_component_kind_deduction": "Удержание",
  "compensation_component_kind_employer_contribution": "Взнос работодателя",
  "compensation_component_calculation_settings": "Участие в расчётах",
  "compensation_component_is_included_in_gross": "Входит в сумму до удержаний",
  "compensation_component_is_included_in_gross_description": "Учитывать компонент в общей сумме начислений до удержаний.",
  "compensation_component_is_payable_to_employee": "Выплачивается сотруднику",
  "compensation_component_is_payable_to_employee_description": "Учитывать компонент в сумме, выплачиваемой сотруднику.",
  "compensation_component_is_included_in_total_cost": "Входит в стоимость для компании",
  "compensation_component_is_included_in_total_cost_description": "Учитывать компонент в общей стоимости сотрудника для компании.",
  "compensation_component_is_off_payroll": "Вне зарплатной ведомости",
  "compensation_component_is_off_payroll_description": "Компонент учитывается отдельно от расчёта зарплаты.",
  "compensation_component_is_statutory_base": "Входит в базу обязательных расчётов",
  "compensation_component_is_statutory_base_description": "Учитывать компонент при расчётах, установленных законом.",
  "create_compensation_component": "Создать компонент компенсации",
  "edit_compensation_component": "Изменить компонент компенсации",
  "archive_compensation_component_confirm": "Архивировать этот компонент компенсации?",
  "confirm_and_copy": "Подтвердить и скопировать",
  "confirmation_email_sent": "Письмо для подтверждения отправлено на {email}. Проверьте свой почтовый ящик",
  "contacts": "Контакты",
  "contract": "Контракт",
  "contract_details": "Детали контракта",
  "copy": "Копия",
  "to_copy": "Скопировать",
  "copy_invitation_link": "Скопировать ссылку приглашения",
  "copy_invitation_link_caption": "Скопировать ссылку и выбрать адрес, на который сотруднику придёт код для входа",
  "copy_invitation_link_email_description": "Выберите адрес, на который придёт код для входа, когда сотрудник откроет ссылку. Сама ссылка только копируется.",
  "core_company_calendar": "Корпоративный календарь",
  "core_company_calendar_description": "Управление корпоративными событиями, праздниками и важными датами",
  "core_hr": "Управление персоналом",
  "country": "Страна",
  "create_document": "Создать документ",
  "documents_drop_to_upload": "Перетащите файлы для загрузки",
  "documents_uploading_files": "Загрузка файлов...",
  "documents_upload_done": "Загрузка завершена",
  "create_folder": "Создать папку",
  "create_message": "Создать сообщение",
  "create_new_rule": "Создать новое правило",
  "rule_group_mode_all": "Все правила ниже",
  "rule_group_mode_any": "Любое из правил ниже",
  "rule_group_mode_combination": "Комбинация групп правил",
  "rule_group_add_group": "Добавить группу",
  "rule_group_title": "Группа {number}",
  "rule_group_caption": "Здесь собраны все правила группы",
  "rule_group_or": "ИЛИ",
  "create_role_from_settings_caption": "Мы скопируем все настройки кроме данных о том, на кого назначена роль",
  "create_role_from_settings_title": "Создать новую роль с этими настройками",
  "create_team": "Создать команду",
  "create_teammate": "Создать сотрудника",
  "data_access_limitations": "Ограничения доступа к данным",
  "data_access_limitations_description": "Определите, к данным каких сотрудников имеет доступ эта роль",
  "data_access_rules_applied": "Применяются правила доступа к данным",
  "data_access_rules_applied_tooltip": "Участники с этой ролью будут видеть данные только тех сотрудников, которые разрешены правилами доступа к данным.",
  "default_employee_background": "Фоновое изображение сотрудника по умолчанию",
  "background_apply_to": "Кому установить фон",
  "background_apply_to_new_employees": "Только новым сотрудникам",
  "background_apply_to_without_own_background": "Тем, кто не менял фон",
  "background_apply_to_all_employees": "Всем сотрудникам, включая сменивших фон",
  "default_theme": "Стиль по умолчанию",
  "delete_employee": "Удалить сотрудника",
  "delete_employee_caption": "Безвозвратно удалить из системы",
  "delete_employee_confirm": "Вы уверены, что хотите безвозвратно удалить этого сотрудника? Это действие нельзя отменить.",
  "delete_employee_handover_description": "Выберите, кому передать дела удаляемого сотрудника. %APP_NAME% автоматически передаст ответственность и закроет запросы, которые нельзя переназначить",
  "delete_employee_success": "Сотрудник {name} удалён",
  "delete_link_question": "Вы хотите удалить ссылку?",
  "delete_photo": "Удалить фото",
  "delete_photo_caption": "Удалить текущее фото профиля",
  "delete_request_confirm_description": "Вы уверены, что хотите удалить запрос?",
  "delete_rule_question": "Вы хотите удалить правило?",
  "delete_team": "Удалить команду",
  "delete_team_question": "Вы уверены, что хотите удалить эту команду?",
  "department": "Отдел",
  "department_lead": "Руководитель отдела",
  "department_lead_prefix": "Рук. в",
  "department_manager": "Руководитель отдела",
  "departments": "Отделы",
  "all_subordinates": "Все подчинённые",
  "direct_reports": "Прямые подчиненные",
  "no_direct_reports": "Нет прямых подчинённых",
  "employee_overview_no_direct_reports": "Прямых подчинённых пока нет",
  "employee_overview_no_direct_reports_description": "Они появятся здесь, когда вы укажете этого человека как руководителя в профилях коллег",
  "employee_overview_no_direct_reports_button": "Назначить подчинённых",
  "no_department_assigned": "Отдел не назначен",
  "employee_overview_no_department_assigned": "Отдел не назначен",
  "employee_overview_no_department_assigned_description": "Коллеги появятся здесь, когда вы укажете отдел",
  "employee_overview_no_department_assigned_button": "Назначить отдел",
  "no_department_employees": "В этом отделе пока нет сотрудников",
  "employee_overview_no_department_employees": "В этом отделе пока нет коллег",
  "employee_overview_no_department_employees_description": "Коллеги появятся здесь, когда в этот отдел добавят сотрудников",
  "employee_overview_no_department_employees_button": "Перейти к сотрудникам",
  "disable_2fa": "Отключить двухфакторную аутентификацию",
  "disable_2fa_caption": "Сбросить двухфакторную аутентификацию сотрудника",
  "disable_access": "Отключить доступ к системе",
  "disable_access_caption": "Сотрудник не сможет войти в систему",
  "disable_access_confirm": "Вы уверены, что хотите отключить доступ к системе для этого сотрудника? Он больше не сможет войти в систему.",
  "division": "Подразделение",
  "divisions": "Подразделения",
  "document": "Документ",
  "documents": "Документы",
  "esign": "Электронная подпись",
  "edit_employee": "Изменить профиль сотрудника",
  "edit_employee_caption": "Личная информация, день рождения, контакты и т.д.",
  "edit_employee_menu_title": "Профиль сотрудника",
  "edit_employee_sub_caption": "Фото, фон, личные данные",
  "edit_link": "Изменить ссылку",
  "edit_manage_profile": "Изменить настройки аккаунта",
  "edit_manage_profile_menu_title": "Настройки аккаунта",
  "edit_request": "Редактировать запрос",
  "edit_rule": "Изменить правило",
  "edit_signing": "Изменить подписантов и поля",
  "edit_signing_description": "Изменить, кто и где подписывает",
  "edit_team": "Изменить команду",
  "eligible_for_rehire": "Рассматривать для повторного найма",
  "email": "Электронная почта",
  "esign_add_signer": "Добавить подписанта",
  "esign_change_signer": "Сменить подписанта",
  "esign_change_type": "Сменить тип",
  "esign_font_size": "Размер шрифта",
  "esign_sample_signature": "Иван Иванов",
  "esign_sample_full_name": "Иван Петрович Иванов",
  "esign_sample_initials": "И.И.",
  "esign_sample_job_title": "Инженер-программист",
  "esign_sample_job_role": "Разработка",
  "esign_sample_job_level": "Старший",
  "esign_sample_text": "Текст",
  "esign_sample_yes_no": "Да / Нет",
  "esign_field_text": "Текст",
  "esign_field_yes_no": "Да/Нет",
  "esign_filled_by": "Кто заполняет",
  "esign_filled_by_auto": "Автоматически",
  "esign_filled_by_sender": "Отправитель",
  "esign_filled_by_signer": "Подписант",
  "esign_sender_fills_option": "Отправитель (при отправке)",
  "esign_field_required": "Обязательное",
  "esign_field_multiline": "Многострочное",
  "esign_delete_signer": "Удалить подписанта...",
  "esign_edit_signer": "Редактировать подписанта",
  "esign_field_current_date": "Дата подписания",
  "esign_field_full_name": "Полное имя",
  "esign_field_initials": "Инициалы",
  "esign_field_job_title": "Должность",
  "esign_field_signature": "Подпись",
  "esign_click_to_sign": "Нажмите, чтобы подписать",
  "esign_continue_reading": "Продолжить чтение",
  "esign_email_verification": "Подтвердите адрес электронной почты",
  "esign_finish_signing": "Подписать",
  "esign_status_declined": "Отклонён",
  "esign_decline": "Отказаться подписать",
  "esign_decline_title": "Отказаться подписать",
  "esign_decline_description": "Подписание отменится для всех участников, отправитель получит уведомление.",
  "esign_decline_reason_label": "Причина (необязательно)",
  "esign_decline_withdraw_consent": "Хочу получать документы на бумаге: отозвать согласие на электронные документы",
  "esign_decline_confirm": "Отказаться",
  "esign_declined_toast": "Вы отказались подписать документ",
  "esign_consent_agree": "Я прочитал(а) согласие и согласен(на) получать и подписывать документы электронно",
  "esign_consent_disagree": "Не согласен(на): отказаться подписать",
  "esign_i_have_read_and_acknowledge": "Подтверждаю ознакомление",
  "esign_next_field": "Далее",
  "esign_otp_code_label": "Код подтверждения",
  "esign_otp_invalid": "Неверный код.",
  "esign_otp_resend": "Отправить код повторно",
  "esign_otp_resend_in": "Отправить код повторно через {seconds} с…",
  "esign_otp_resend_inline": "отправьте код повторно",
  "esign_otp_sent": "Мы отправили код подтверждения на адрес",
  "esign_otp_sent_fallback": "вашу электронную почту",
  "esign_otp_try_again": "Повторите попытку или",
  "esign_otp_verified": "Электронная почта подтверждена",
  "esign_signing": "Подписание",
  "esign_start_signing": "Начать",
  "esign_unsigned_fields_left": "{count, plural, one {# неподписанное поле в документе} few {# неподписанных поля в документе} many {# неподписанных полей в документе} other {# неподписанных полей в документе}}",
  "esign_your_signature": "Ваша подпись",
  "esign_read_and_agree": "Ознакомиться",
  "esign_sign": "Подписать",
  "esign_read_to_end_hint": "Прочитайте документ до конца, чтобы подтвердить",
  "esign_ready_to_sign_description": "Запросите подписи сейчас или вернитесь позже.",
  "esign_ready_to_sign_title": "Документ готов к подписанию",
  "esign_request_now": "Запросить сейчас",
  "esign_request_awaiting_signature": "Документ ожидает вашей подписи",
  "esign_request_awaiting_acknowledgment": "Документ ожидает вашего ознакомления",
  "esign_request_signatures": "Запросить подписи",
  "esign_request_signatures_description": "Получатель подпишет документ",
  "esign_acknowledgment_request_sent": "Запрос на ознакомление отправлен",
  "esign_request_acknowledgment": "Запросить ознакомление",
  "esign_request_acknowledgment_description": "Получатель прочитает и подтвердит",
  "esign_request_sent_notified": "{count, plural, one {# получатель уведомлён.} few {# получателя уведомлены.} many {# получателей уведомлены.} other {# получателя уведомлены.}}",
  "esign_signature_request_sent": "Запрос на подпись отправлен",
  "esign_recipient_required": "Выберите хотя бы одного получателя",
  "esign_choose_recipient": "Выберите получателя...",
  "esign_send_to": "Отправить",
  "esign_multiple_recipients": "нескольким получателям",
  "rule_total_employees": "{count, plural, one {Всего # сотрудник} few {Всего # сотрудника} many {Всего # сотрудников} other {Всего # сотрудника}}",
  "rule_names_and_others": "{names} и ещё {count, plural, one {# человек} few {# человека} many {# человек} other {# человека}}",
  "esign_return_to": "Вернуться к",
  "esign_single_recipient": "одному получателю",
  "esign_recipients_count": "{count, plural, one {# получатель} few {# получателя} many {# получателей} other {# получателя}}",
  "esign_requests_count": "{count, plural, one {# запрос} few {# запроса} many {# запросов} other {# запроса}}",
  "esign_personas": "Персоны",
  "esign_signature_certificate": "Сертификат подписи",
  "esign_acknowledgment_certificate": "Сертификат ознакомления",
  "esign_show_signature_certificate": "Показать сертификат подписи",
  "esign_show_acknowledgment_certificate": "Показать сертификат ознакомления",
  "esign_request_created_by": "Кем создано",
  "esign_signed_by": "Кем подписано",
  "esign_acknowledged_by": "Кем ознакомлено",
  "esign_signed_on_prefix": "От",
  "esign_download_signed_document": "Скачать подписанный документ",
  "esign_download_acknowledged_document": "Скачать документ",
  "esign_download_report": "Загрузить отчёт",
  "esign_reminder_custom": "Свой интервал…",
  "esign_reminder_custom_title": "Свой интервал",
  "esign_reminder_every_days": "{count, plural, one {Каждый # день} few {Каждые # дня} many {Каждые # дней} other {Каждые # дня}}",
  "esign_reminder_every_months": "{count, plural, one {Каждый # месяц} few {Каждые # месяца} many {Каждые # месяцев} other {Каждые # месяца}}",
  "esign_reminder_every_weeks": "{count, plural, one {Каждую # неделю} few {Каждые # недели} many {Каждые # недель} other {Каждые # недели}}",
  "esign_remind_every": "Напоминать каждые",
  "esign_reminder_frequency": "Частота напоминаний",
  "esign_reminders": "Напоминания",
  "esign_reminders_regular": "Обычные напоминания",
  "esign_reminders_smart": "Умные напоминания",
  "esign_select_due_date": "Выберите срок",
  "esign_select_recipient_first": "Сначала выберите получателя",
  "esign_replace_existing_document": "Заменить существующий документ",
  "esign_replace_source_hint": "Подписанный документ заменит исходный файл.",
  "esign_no_store_folders": "Нет папок, в которые вы можете сохранить документ. Обратитесь к администратору.",
  "esign_store_path_docs": "Документы",
  "esign_store_path_profile": "Профиль сотрудника",
  "esign_store_signed_document": "Куда сохранить подписанный документ",
  "esign_select_custom_field": "Выберите поле",
  "esign_select_employee": "Выберите сотрудника",
  "esign_signer_custom_field": "Сотрудник из кастомного поля",
  "esign_signer_direct_manager": "Руководитель сотрудника",
  "esign_signer_employee": "Сотрудник",
  "esign_signer_select": "Выбрать",
  "esign_signer_specific_employee": "Конкретный сотрудник",
  "esign_signer": "Подписант",
  "esign_signer_type": "Тип подписанта",
  "esign_signers": "Подписанты",
  "esign_fields_to_fill": "Поля для заполнения",
  "esign_sender_fields_shared_hint": "Эти значения будут применены ко всем конвертам. Индивидуальные значения для получателей не поддерживаются.",
  "email_bcc_email": "Скрытая копия",
  "email_cc_email": "Копия",
  "email_enter_body": "Введите текст письма",
  "email_enter_recipient": "Введите адрес получателя",
  "email_from": "От кого",
  "email_income_server": "Сервер для входящих писем",
  "email_not_confirmed": "Электронная почта не подтверждена",
  "email_noun": "Письмо",
  "email_outgoing_server": "Сервер для исходящих писем",
  "email_personal": "Личная электронная почта",
  "email_personal_copied": "Личная электронная почта скопирована",
  "email_placeholder_candidate_email": "Электронная почта кандидата",
  "email_placeholder_candidate_first_name": "Имя кандидата",
  "email_placeholder_candidate_full_name": "Полное имя кандидата",
  "email_placeholder_candidate_last_name": "Фамилия кандидата",
  "email_placeholder_sender_email": "Электронная почта отправителя",
  "email_placeholder_sender_first_name": "Имя отправителя",
  "email_placeholder_sender_full_name": "Полное имя отправителя",
  "email_placeholder_sender_job_title": "Должность отправителя",
  "email_placeholder_sender_last_name": "Фамилия отправителя",
  "email_placeholder_sender_phone": "Телефон отправителя",
  "email_servers_settings": "Настройки почтовых серверов",
  "email_short": "Email",
  "email_subject": "Тема",
  "email_template": "Шаблон электронной почты",
  "email_template_enter_body": "Создайте шаблон письма, используя редактор форматированного текста",
  "email_template_my": "Мои шаблоны",
  "email_template_private": "Личные (видны только вам)",
  "email_template_public": "Общие (видны всем)",
  "email_template_shared": "Общие",
  "email_templates": "Шаблоны электронной почты",
  "email_to": "Кому",
  "email_with_password_reset_was_sent": "Мы отправили ссылку для сброса пароля на указанный вами адрес электронной почты. Пожалуйста, проверьте свой почтовый ящик и следуйте инструкциям для сброса пароля",
  "employee": "Сотрудник",
  "employee_id": "ID сотрудника",
  "employee_is_member_of_team_template": "{employee_name} в команде {period}",
  "employee_number": "Табельный номер",
  "employee_number_enabled_title": "Автонумерация табельного номера",
  "employee_number_enabled_description": "Новый сотрудник автоматически получит табельный номер",
  "employee_number_next_value_title": "Следующий номер",
  "employee_termination_menu_new_description": "Чтобы уволить сотрудника, откройте «Действия» -> «Изменить рабочие данные».",
  "employee_termination_menu_new_title": "Увольнение теперь в меню действий",
  "employees": "Сотрудники",
  "employment": "Занятость",
  "employment_contract": "Трудовой договор",
  "employment_contracts": "Трудовые договоры",
  "employment_duration": "Срок трудоустройства",
  "employment_end_date": "Дата окончания занятости",
  "employment_ended": "Трудоустройство завершено",
  "employment_start_date": "Дата начала занятости",
  "employment_statuses": "Статусы занятости",
  "employment_type": "Тип занятости",
  "employment_types": "Типы занятости",
  "empty_mention_text": "Попробуйте найти сотрудника",
  "enable_access": "Включить доступ к системе",
  "enable_access_caption": "Сотрудник сможет снова войти в систему",
  "enable_access_confirm": "Вы уверены, что хотите включить доступ к системе для этого сотрудника? Он сможет снова войти в систему.",
  "enable_probation_period": "Включить испытательный срок",
  "ends_on": "Завершится",
  "ends_on_period": "Завершится {period_end} ({days_to_end})",
  "enter_code_from_authenticator": "Введите код из вашего приложения-аутентификатора",
  "enter_invitation_body_text": "Введите текст приглашения",
  "expiry_days_value": "Период истечения (дней)",
  "extension_display_type_popup": "Всплывающее окно",
  "extension_display_type_popup_side_panel": "Боковая панель",
  "extension_display_type_setting_title": "Режим отображения расширения браузера",
  "extension_appearance_caption": "Выберите, как будет открываться расширение",
  "extension_appearance_title": "Внешний вид расширения Chrome",
  "features": "Функции",
  "first_name": "Имя",
  "first_scale_options": "Варианты первой шкалы",
  "folder": "Папка",
  "folder_root": "Корень",
  "forgot_password": "Забыли пароль?",
  "frequency": "Частота",
  "full_name": "Полное имя",
  "gender": "Пол",
  "login_method_password": "Вход по паролю",
  "login_method_password_description": "Разрешить сотрудникам входить с рабочей почтой и паролем",
  "login_method_google": "Вход через Google",
  "login_method_google_description": "Разрешить сотрудникам входить с аккаунтом Google",
  "google_workspace_domains": "Домены Google Workspace",
  "google_workspace_domains_hint": "Ограничить вход через Google этими доменами Workspace. Несколько — через запятую; пустое поле ограничений не накладывает.",
  "google_workspace_domains_invalid": "Укажите домен, например yourcompany.com — не адрес почты целиком",
  "login_methods_none_working": "Должен остаться хотя бы один включённый и настроенный способ входа",
  "password_login_unavailable": "Вход по паролю недоступен для этой учётной записи. Выберите другой способ входа.",
  "entra_sso": "Вход через Microsoft Entra ID",
  "entra_sso_description": "Разрешить сотрудникам входить с рабочим аккаунтом Microsoft",
  "entra_sso_tenant_ids": "Tenant ID",
  "entra_sso_tenant_ids_hint": "Directory (tenant) ID из Microsoft Entra ID. Несколько — через запятую.",
  "entra_sso_tenant_ids_invalid": "Укажите tenant ID в формате GUID, например 00000000-0000-0000-0000-000000000000",
  "entra_sso_tenant_ids_required": "Добавьте хотя бы один tenant ID, чтобы включить вход",
  "oidc_sso": "Вход через SSO (OpenID Connect)",
  "oidc_sso_description": "Разрешить сотрудникам входить через ваш провайдер учётных записей: Keycloak, Okta, Auth0 и другие",
  "oidc_sign_in_appearance": "Отображение на странице входа",
  "oidc_provider_connection": "Подключение к провайдеру",
  "oidc_user_data": "Данные пользователя",
  "oidc_title": "Название кнопки",
  "oidc_title_hint": "Эту кнопку сотрудник увидит на странице входа после ввода почты",
  "oidc_issuer": "Адрес издателя (Issuer URL)",
  "oidc_issuer_hint": "Для Keycloak: https://<хост>/realms/<realm>. При сохранении по этому адресу загружаются настройки OpenID",
  "oidc_issuer_invalid": "Укажите адрес издателя, который начинается с https://",
  "oidc_client_id": "Client ID",
  "oidc_client_secret": "Client secret",
  "oidc_client_secret_hint": "Секрет сохранён. Оставьте поле пустым, чтобы не менять его",
  "oidc_email_claim": "Claim с почтой",
  "oidc_email_claim_hint": "Поле с рабочей почтой пользователя",
  "oidc_email_claim_tooltip": "Claim ID-токена с рабочей почтой: email, preferred_username или upn.",
  "oidc_scopes": "Scopes",
  "oidc_scopes_hint": "Обязательные scopes: openid, email, profile",
  "oidc_scopes_required": "Добавьте обязательные scopes: openid, email, profile",
  "oidc_scopes_tooltip": "Добавляйте scopes, которые требует ваш провайдер. Не удаляйте обязательные: openid, email и profile нужны для входа и получения данных пользователя.",
  "oidc_redirect_uri": "Redirect URI",
  "oidc_redirect_uri_hint": "Добавьте этот адрес в разрешённые redirect URI клиента у провайдера",
  "ip_allowlist": "Доступ по IP",
  "ip_allowlist_enabled": "Пускать только с указанных IP-адресов",
  "ip_allowlist_enabled_description": "Вход, приложение, API и MCP работают только с этих адресов. Запросы с остальных отклоняются",
  "ip_allowlist_networks": "IP-адреса и подсети",
  "ip_allowlist_networks_hint": "По одному в строке или через запятую. IPv4 и IPv6, подсети в формате CIDR: 203.0.113.0/24, 2001:db8::/32",
  "ip_allowlist_networks_required": "Добавьте хотя бы один адрес или подсеть",
  "ip_allowlist_current_ip": "Ваш текущий IP-адрес: {ip}. Он должен быть в списке, иначе сохранить не получится",
  "allowed_domains": "Разрешённые домены почты",
  "allowed_domains_hint": "Рабочую почту сотрудника можно менять только на адрес в этих доменах. Несколько — через запятую; пустое поле ограничений не накладывает.",
  "allowed_domains_invalid": "Укажите домен, например yourcompany.com — не адрес почты целиком",
  "grant_access_to_table": "Предоставить доступ для просмотра и изменения всех существующих и будущих столбцов",
  "groups": "Группы",
  "heads_of_departments": "Руководители отделов",
  "help_how_can_i_help_you": "С чем мы можем вам помочь?",
  "hire_date": "Дата начала работы",
  "hired_on": "Дата начала работы",
  "home": "Главная",
  "customize_home_screen": "Настроить экран",
  "configure_home_screen": "Настроить главный экран",
  "home_widget_my_company": "Моя компания",
  "settings_home_layout_title": "Главный экран",
  "settings_home_layout_description": "Порядок и видимость блоков главного экрана по умолчанию для сотрудников",
  "home_layout_lock": "Закрепить видимость",
  "home_layout_locked_hint": "Видимость закреплена, сотрудник не может её изменить",
  "onboarding_home_title": "Добро пожаловать в команду",
  "preboarding_start": "Начать",
  "preboarding_welcome": "Добро пожаловать в {company}",
  "preboarding_journey": "Ваш путь в {company} начнётся через {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}.",
  "preboarding_journey_hint": "Осталось пройти несколько шагов до первого рабочего дня",
  "preboarding_journey_done": "Вы прошли все шаги — ждём вас в первый рабочий день.",
  "preboarding_surveys_title": "Опросы для заполнения",
  "preboarding_esign_title": "Документы на подпись",
  "preboarding_tasks_title": "Задачи к выполнению",
  "preboarding_task_attachments_title": "Вложения",
  "preboarding_empty_title": "Задач пока нет",
  "preboarding_empty_description": "Заполнять ничего не нужно — ждём вас в первый рабочий день.",
  "preboarding_error_title": "Не удалось загрузить страницу",
  "settings_preboarding_title": "Пребординг",
  "settings_preboarding_description": "Настройте, что видит новый сотрудник до первого рабочего дня",
  "preboarding_settings_always_shown_title": "Отображается всегда",
  "preboarding_settings_always_shown_description": "Опросы и документы на подпись всегда показываются на главном экране пребординга.",
  "preboarding_settings_show_manager": "Показывать руководителя",
  "preboarding_settings_show_manager_description": "Показывать имя, фото и должность руководителя на главном экране пребординга",
  "portal_access": "Доступ к порталу",
  "portal_access_menu_caption": "Посмотреть, почему у сотрудника ограничен портал",
  "portal_access_mode_preboarding": "Ограничен до выхода",
  "portal_access_mode_onboarding": "Ограничен, пока идут процессы",
  "portal_access_mode_full": "Полный доступ",
  "portal_access_mode_hint": "Сотрудник видит только назначенные ему опросы и документы на подпись",
  "portal_access_blocking_now": "Ограничивает доступ",
  "portal_access_not_blocking": "Уже не ограничивает",
  "portal_access_blocking_processes": "Процессы, ограничивающие доступ",
  "portal_access_no_blockers": "Ограничений нет",
  "portal_access_no_blockers_preboarding": "Сотрудник получит полный доступ в первый рабочий день.",
  "portal_access_released_hint": "Ограничение сняли вручную — вернуть его уже нельзя.",
  "portal_access_released": "Ограничение снято вручную",
  "portal_access_add_workflows": "Добавить процесс...",
  "portal_access_replace_workflows": "Заменить процессы...",
  "portal_access_add_workflows_hint": "Пока выбранные процессы не завершатся, сотрудник останется с ограниченным доступом.",
  "portal_access_replace_workflows_hint": "Текущие ограничения снимутся, когда запустится первый новый процесс. Портал откроется, когда завершатся все выбранные.",
  "portal_access_release": "Снять ограничение вручную...",
  "portal_access_release_submit": "Снять ограничение",
  "portal_access_release_hint": "Сотрудник сразу получит полный доступ. Уже запущенные процессы продолжат выполняться.",
  "portal_access_release_hint_preboarding": "Процессы перестанут ограничивать портал, но полный доступ откроется только в первый рабочий день. Уже запущенные процессы продолжат выполняться.",
  "portal_access_release_success": "Ограничение снято",
  "portal_access_run_success": "Процессы запущены",
  "portal_access_partial_error": "Часть процессов не запустилась. Повтор запустит только их.",
  "portal_access_permission_view_description": "Видеть, почему у сотрудника ограничен портал",
  "portal_access_permission_edit_description": "Видеть, почему ограничен портал, запускать ограничивающие процессы и снимать ограничение вручную",
  "impersonate_employee": "Войти как сотрудник",
  "impersonate_employee_caption": "Открыть портал в новой вкладке и работать от лица сотрудника",
  "impersonation_banner": "Вы просматриваете портал как {name}. Сессия завершится в {time}",
  "impersonation_ended_close": "Закрыть вкладку",
  "impersonation_ended_description": "Сессия входа за сотрудника истекла или была завершена. Закройте вкладку и при необходимости начните заново",
  "impersonation_ended_title": "Сессия входа за сотрудника завершена",
  "impersonation_exit": "Выйти",
  "import_data_continue_to_matching": "Перейти к сопоставлению",
  "import_data_exit_confirm": "Вы уверены, что хотите выйти? Весь прогресс будет потерян",
  "import_data_file_name": "Имя файла",
  "import_data_history": "История импортов",
  "import_data_review_import": "Проверить импорт",
  "import_data_start_import": "Начать импорт",
  "import_data_start_new": "Новый импорт",
  "import_data_step_confirmation": "Подтверждение",
  "import_data_step_preset": "Тип импорта",
  "import_data_step_preview": "Предпросмотр данных",
  "import_data_step_common_settings": "Настройки импорта",
  "import_data_step_match": "Сопоставление колонок",
  "in_app": "В приложении",
  "messenger": "Мессенджер",
  "invitation_link_copied_to_clipboard": "Ссылка приглашения скопирована в буфер обмена",
  "invite_code_description": "Мы отправили 6-значный код для входа на адрес, использованный для приглашения.",
  "invite_code_resend": "Запросить новый код",
  "invite_invalid_description": "Войдите в систему или восстановите пароль.",
  "invite_invalid_title": "Это приглашение уже было использовано или недействительно.",
  "invite_to_skailer": "Пригласить сотрудника в %APP_NAME%",
  "invited": "Приглашен",
  "join_workspace_of_your_team": "Присоединяйтесь к пространству вашей команды в %APP_NAME%",
  "last_action": "Последнее действие",
  "last_activity_date": "Последняя активность",
  "last_name": "Фамилия",
  "last_working_day": "Последний рабочий день",
  "leave_type": "Тип",
  "legal_entities": "Юридические лица",
  "legal_entity": "Юридическое лицо",
  "level": "Уровень",
  "levels": "Уровни",
  "lifecycle_status": "Статус сотрудника",
  "lifecycle_active": "Активен",
  "lifecycle_inactive": "Неактивен",
  "lifecycle_status_employed": "Устроен",
  "lifecycle_status_hired": "Нанят",
  "lifecycle_status_on_leave": "Отсутствует",
  "lifecycle_status_on_parental_leave": "Отсутствует по уходу за ребенком",
  "lifecycle_status_set_date": "Установить дату",
  "lifecycle_status_terminated": "Уволен",
  "lifecycle_status_terminated_on": "{date} · {ago}",
  "links": "Ссылки",
  "login_organization_placeholder": "Организация",
  "login_organization_session_expired": "Время входа истекло. Войдите заново.",
  "login_select_organization": "Выберите организацию",
  "login_select_organization_subtitle": "Ваш адрес заведён в нескольких организациях. Выберите, куда войти.",
  "login_to_platform": "Войти в %APP_NAME%",
  "login_to_platform_subtitle": "Желаем вам хорошего дня",
  "make_changes": "Внести изменения",
  "manage_access": "Управление доступом",
  "manage_access_caption": "Приглашения, 2FA, доступ к системе",
  "manual_setup": "Ручная настройка",
  "manage_compensation": "Управление компенсацией",
  "manage_compensation_description": "Полный доступ ко всем полям компенсации и истории изменений",
  "permission_employee_compensation_lines_title": "Строки компенсации",
  "permission_employee_compensation_lines_description": "Просмотр или управление строками, из которых состоит компенсационный пакет сотрудника",
  "permission_employee_compensation_total_cost_title": "Полная стоимость для компании",
  "permission_employee_compensation_total_cost_description": "Просмотр полной стоимости сотрудника с учётом взносов работодателя",
  "permission_reporting_employee_total_cost_title": "Отчёт по полной стоимости для компании",
  "permission_reporting_employee_total_cost_description": "Просмотр отчёта по полной стоимости сотрудников. Требуется доступ к отчёту по зарплатам",
  "manage_employment": "Управление занятостью",
  "manage_employment_description": "Полный доступ ко всем полям занятости и истории изменений",
  "manage_position": "Управление должностью",
  "manage_position_description": "Полный доступ ко всем полям должности и истории изменений",
  "manage_profile_caption": "Пароль, интеграции, уведомления и т.д.",
  "manage_teams": "Управление командами",
  "manage_teams_settings_permission_edit_description": "Полный доступ к созданию, изменению и удалению команд",
  "manage_teams_settings_permission_none_description": "Информация о команде скрыта с профилей сотрудников",
  "manage_teams_settings_permission_view_description": "Пользователи видят команды, но не могут их изменять",
  "manage_views": "Управление представлениями",
  "changed_by": "Кто изменил",
  "manager": "Руководитель",
  "managers": "Руководители",
  "is_manager": "Является руководителем",
  "member": "Участник",
  "members": "Участники",
  "mention": "Упоминание",
  "mentions": "Упоминания",
  "message_from_app": "Сообщение от %APP_NAME%",
  "message_template": "Шаблон сообщения",
  "middle_name": "Отчество",
  "min_length_value": "Минимальная длина (символов)",
  "my_company_template": "{company}",
  "my_details": "Мои данные",
  "my_manager": "Мой руководитель",
  "my_profile": "Профиль",
  "my_subordinates": "Мои подчиненные",
  "name": "Имя",
  "name_display_format": "Формат отображения имени",
  "search_personal_data_placeholder": "Имя, фамилия, другие персональные данные…",
  "set_all_permissions": "Вы можете выбрать уровень доступа для всех записей текущего раздела",
  "set_all_permissions_edit": "Максимальный доступ",
  "set_all_permissions_none": "Без доступа",
  "set_all_permissions_select": "Выбрать",
  "set_all_permissions_view": "Доступ на просмотр",
  "new_employee": "Новый сотрудник",
  "new_employee_invitation_sent": "Приглашение успешно отправлено на {email}",
  "new_employee_manual_invitation_description": "Письмо с инструкциями не будет отправлено автоматически. Вы можете отправить его со страницы сотрудника",
  "new_mentions": "Новые упоминания",
  "new_request": "Новый запрос",
  "new_team": "Создать команду",
  "new_teammate_added": "Новый сотрудник добавлен!",
  "news": "Новости",
  "news_feature_description": "Делитесь корпоративными объявлениями, событиями и важными обновлениями",
  "no_compensation_assigned": "Компенсация не назначена",
  "no_documents_created": "Документы не добавлены",
  "no_documents_created_description": "Храните подписанные контракты, соглашения, запросы на отсутствие и т. д.",
  "no_employment_assigned": "Занятость не назначена",
  "no_position_assigned": "Должность не назначена",
  "no_team_created": "Команда не добавлена",
  "employee_overview_no_team_membership": "Сотрудник не состоит в командах",
  "employee_overview_no_team_membership_description": "Команды появятся здесь, когда вы добавите сотрудника хотя бы в одну",
  "employee_overview_no_team_membership_button": "Добавить в команду",
  "no_teams_created_description": "Создавайте команды, управляйте участниками и ролями",
  "no_reminders_sent": "Напоминания ещё не отправлялись",
  "notes": "Заметки",
  "notification_settings": "Настройки уведомлений",
  "notification_settings_no_available": "Нет доступных настроек уведомлений",
  "notification_settings_no_available_description": "В настоящее время у вас нет доступных настроек уведомлений.",
  "employee_not_started_yet": "Сотрудник выходит {date}",
  "on_probation_till": "На исп. сроке до",
  "onboarding_setup": "Настройки адаптации",
  "org_chart_departments": "Отделы",
  "org_chart_employees": "Оргструктура",
  "organization": "Организация",
  "organization_link": "Полезная ссылка",
  "organization_links": "Полезные ссылки",
  "organization_settings": "Настройки организации",
  "organization_view_filter_description": "Определите, какие сотрудники будут видны при первом открытии раздела",
  "organization_view_filter_title": "Представление сотрудников по умолчанию",
  "parent_department": "Родительский отдел",
  "password_expired_description": "В целях безопасности вам необходимо изменить пароль",
  "password_expired_title": "Срок действия вашего пароля истёк",
  "password_expiry_days": "Истечение срока действия пароля",
  "password_expiry_days_description": "Требовать от пользователей менять пароли через определённое количество дней",
  "password_min_length": "Минимальная длина пароля",
  "password_min_length_description": "Установить минимальное количество символов для паролей",
  "password_policy": "Политика паролей",
  "password_updated": "Ваш пароль успешно обновлен",
  "people": "Люди",
  "people_with_activity": "Сотрудники с действиями",
  "peoples_data": "Данные сотрудников",
  "permission_reporting_export_title": "Экспорт отчетов",
  "permissions_access_to_leave_timeline": "Доступ к календарю отсутствий",
  "permissions_access_to_leave_timeline_description": "Доступ к календарю подтвержденных отпусков и других видов отсутствий сотрудников, к профилям которых у роли есть доступ",
  "permissions_add_new_employees": "Создавать новых сотрудников",
  "permissions_add_new_employees_description": "Разрешить пользователям добавлять новых сотрудников в систему",
  "permissions_approve_and_reject_leaves": "Утверждение и отклонение отсутствий",
  "permissions_approve_and_reject_leaves_description": "Создание, одобрение и отклонение заявлений на отсутствие других сотрудников, минуя все ограничения",
  "permissions_ban_employees": "Управление доступом к системе",
  "permissions_ban_employees_description": "Разрешить пользователям включать или отключать доступ сотрудников к системе",
  "permissions_custom_fields_description": "Настройте и отсортируйте поля, которые будут отображаться в профиле сотрудника",
  "permissions_delete_employees": "Удаление сотрудников",
  "permissions_delete_employees_description": "Разрешить пользователям безвозвратно удалять профили сотрудников из системы",
  "permissions_impersonate_employees": "Вход за сотрудника",
  "permissions_impersonate_employees_description": "Разрешить пользователям открывать портал от лица сотрудника, чтобы видеть его глазами сотрудника",
  "permissions_employees_search": "Поиск по сотрудникам",
  "permissions_employees_search_description": "Искать сотрудников по отделам, должностям и другим критериям",
  "permissions_esign_manage_templates_title": "Управление разметкой подписей",
  "permissions_esign_manage_templates_description": "Просмотр и управление разметкой подписей в документах",
  "permissions_esign_request_title": "Запрос подписей",
  "permissions_esign_request_description": "Создание запросов на подписание документов",
  "permissions_esign_download_report_title": "Просмотр отчёта о подписании",
  "permissions_esign_download_report_description": "Просмотр отчёта о подписании документов",
  "permissions_manage_approval_policy": "Политики согласований",
  "permissions_manage_approval_policy_description": "Настройка правил согласований",
  "permissions_manage_calendar_description": "Управление временем и расписанием",
  "permissions_manage_compensation_change_reasons_description": "Управление причинами корректировки окладов",
  "permissions_manage_compensation_types_description": "Управление типами бонусов и другими дополнительными выплатами",
  "permissions_manage_custom_fields_description": "Настройка полей профиля сотрудника, кандидата, вакансии и оффера",
  "permissions_manage_data_protection_description": "Управлять настройками конфиденциальности и защиты данных",
  "permissions_audit_log_read": "Журнал аудита",
  "permissions_audit_log_read_description": "Искать и просматривать системный журнал аудита со всеми действиями пользователей и системными изменениями",
  "permissions_manage_departments_description": "Создавать и управлять отделами, руководителями отделов и организационной структурой",
  "permissions_manage_divisions_description": "Просматривать, создавать или изменять подразделения в организации",
  "permissions_manage_email_templates_description": "Создавать и редактировать шаблоны электронной почты",
  "permissions_manage_hiring_flows": "Управление шаблонами найма",
  "permissions_manage_hiring_flows_description": "Создавать и настраивать шаблоны найма новых сотрудников",
  "permissions_manage_holidays": "Управлять производственными каледнарями",
  "permissions_manage_holidays_description": "Создавать и редактировать производственные календари",
  "permissions_manage_import_data_description": "Загружать данные с помощью файлов",
  "permissions_manage_integrations_description": "Подключать и настраивать Slack, Google Calendar, Google Workspace и Zoom",
  "permissions_manage_leave_policies": "Управление политиками отсутствий",
  "permissions_manage_leave_policies_description": "Изменять политики и правила отсутствий",
  "permissions_manage_legal_entities": "Управлять юридическими лицами",
  "permissions_manage_locations_description": "Управлять местоположениями, связанными с организацией",
  "permissions_manage_organization_description": "Управлять общими настройками организации — название, логотип, язык и т. д.",
  "permissions_manage_organization_links_description": "Управлять ссылками для сотрудников",
  "permissions_manage_positions_description": "Создавать и редактировать должности, устанавливать уровни и т. д.",
  "permissions_manage_probation_policies_description": "Настройте политики испытательного срока сотрудников",
  "permissions_manage_recognitions_description": "Создание и редактирование категорий, признаний и бейджей",
  "permissions_manage_roles_and_permissions_description": "Создавать и редактировать роли и разрешения",
  "permissions_manage_work_patterns_description": "Управление стандартными графиками работы",
  "permissions_recognitions_mass_gift_description": "Отправка признаний группе сотрудников по правилам",
  "permissions_reporting_export_description": "Позволяет экспортировать отчеты в различных форматах",
  "permissions_see_employee_directory": "Просмотр списка сотрудников",
  "permissions_see_employee_directory_description": "Доступ к списку сотрудников и поиск по нему",
  "permissions_terminate_employees_description": "Разрешить пользователям завершать трудовые отношения с сотрудником",
  "permissions_view_departments_chart": "Просмотр структуры отделов",
  "permissions_view_departments_chart_description": "Показать иерархию отделов компании",
  "permissions_view_org_chart": "Просмотр организационной структуры",
  "permissions_view_org_chart_description": "Открыть доступ к структуре компании",
  "personal": "Личное",
  "personal_details": "Персональные данные",
  "personal_information": "Личная информация",
  "phone": "Телефон",
  "phone_personal": "Личный телефон",
  "port": "Порт",
  "position": "Должность",
  "position_details": "Детали должности",
  "position_effective_date": "Дата вступления в должность",
  "positions": "Должности",
  "positions_and_levels": "Должности и уровни",
  "prepare_for_signing": "Настроить подписантов и поля",
  "prepare_for_signing_description": "Укажите, кто и где подписывает",
  "preview": "Предпросмотр",
  "preview_changes": "Просмотр изменений",
  "probation": "Испытательный срок",
  "probation_policies": "Политики испытательного срока",
  "probation_policy": "Политика испытательного срока",
  "probation_till": "Испытательный срок до",
  "profile": "Профиль",
  "question_delete_integration": "Вы хотите удалить данную интеграцию?",
  "reason": "Причина",
  "ready_for_signing": "Готов к подписанию",
  "recognitions": "Признание",
  "recognitions_mass_gift": "Массовая отправка признаний",
  "recipient": "Получатель",
  "reassign_subordinates_to_manager_description": "Автоматически переназначает подчинённых уволенного сотрудника на его руководителя. Если отключено, подчинённые останутся без руководителя",
  "reassign_subordinates_to_manager_title": "Переназначить подчинённых на руководителя",
  "remind": "Напомнить",
  "remind_everyone": "Напомнить всем",
  "reminder": "Напоминание",
  "reminder_history": "История напоминаний",
  "reminder_message": "Сообщение напоминания",
  "customize_reminder_message": "Настроить сообщение напоминания",
  "enter_custom_subject": "Введите тему",
  "enter_custom_body": "Введите текст сообщения",
  "entity": "Объект",
  "last_reminded": "Последнее напоминание {time}",
  "recovery_codes": "Резервные коды",
  "remove_background": "Удалить фон",
  "remove_background_caption": "Удалить текущее фоновое изображение",
  "rename_view": "Переименовать представление",
  "termination_handover_to": "Кому передать дела",
  "termination_handover_to_description": "Выберите, кому передать дела увольняющегося сотрудника. %APP_NAME% автоматически передаст ответственность и закроет запросы, которые нельзя переназначить",
  "require_strong_password": "Требовать сильные пароли",
  "require_strong_password_description": "Пароли должны содержать заглавные, строчные буквы, цифры и специальные символы",
  "require_tfa": "Требовать для всех",
  "send_reminders": "Отправить напоминания",
  "resend_invitation": "Отправить приглашение снова",
  "resend_invitation_caption": "Отправить письмо-приглашение сотруднику повторно",
  "resend_verification_email": "Отправить еще раз",
  "reset_password": "Сбросить пароль",
  "restore_password": "Восстановить пароль",
  "role": "Роль",
  "role_enter_description": "Опишите роль",
  "role_type_admin": "Администраторы имеют доступ ко всему и могут управлять всеми данными",
  "role_type_all_employees": "Все сотрудники — общий доступ",
  "role_type_all_employees_description": "Назначается всем по умолчанию. Здесь настраивается доступ к данным коллег и включение/выключение функций системы для всех сотрудников",
  "role_type_manager": "Определите, что менеджеры могут видеть и редактировать у своих подчиненных",
  "role_type_myself": "Все сотрудники — личные данные",
  "role_type_myself_description": "Определите, что сотрудники могут видеть о себе",
  "role_type_team_leads": "Определите, что тимлиды команд могут видеть и редактировать в своих командах",
  "role_updated": "Роль \"{role_name}\" обновлена",
  "roles": "Роли",
  "roles_and_permissions": "Роли и доступы",
  "roles_basic": "Базовые роли",
  "roles_basic_description": "Роли, применяемые ко всем членам вашей команды по умолчанию, определяют, как они видят профили друг друга и могут редактировать свои собственные профили",
  "roles_custom": "Пользовательские роли",
  "roles_custom_description": "Создавайте пользовательские роли и применяйте их на основе определенных правил",
  "roles_system": "Системные роли",
  "roles_system_description": "Роли, автоматически назначаемые системой, на основе должности сотрудника",
  "rule_admins": "Администраторы",
  "rule_affected_employee": "Целевой сотрудник",
  "rule_affected_employee_caption": "Сотрудник, к которому применяется workflow",
  "rule_affected_employee_custom_field_employee_reference": "Сотрудник из кастомного поля",
  "rule_affected_employee_custom_field_employee_reference_caption": "Сотрудник из кастомного поля целевого сотрудника",
  "rule_affected_employee_custom_field_employee_reference_subordinates": "Подчинённые сотрудника из кастомного поля",
  "rule_affected_employee_custom_field_employee_reference_subordinates_caption": "Подчинённые сотрудника из кастомного поля целевого сотрудника",
  "rule_affected_employee_direct_manager": "Руководитель целевого сотрудника",
  "rule_affected_employee_direct_manager_caption": "Прямой руководитель сотрудника, к которому применяется workflow",
  "rule_affected_employee_direct_manager_subordinates": "Подчинённые руководителя целевого сотрудника",
  "rule_affected_employee_direct_manager_subordinates_caption": "Подчинённые прямого руководителя сотрудника, к которому применяется workflow",
  "rule_affected_employee_subordinates": "Подчинённые целевого сотрудника",
  "rule_affected_employee_subordinates_caption": "Подчинённые сотрудника, к которому применяется workflow",
  "rule_all_active_employees_caption": "Все сотрудники, кроме сотрудников со статусом «Уволен»",
  "rule_custom_field_employee_reference_approval_caption": "Сотрудник из настраиваемого поля сотрудника",
  "rule_custom_field_employee_reference": "Свойство из сотрудника",
  "rule_custom_field_select": "Выбор из настраиваемого поля",
  "rule_custom_field_select_caption": "Фильтр по значению настраиваемого поля типа список",
  "rule_custom_field_select_field_label": "Поле в карточках сотрудников",
  "rule_custom_field_select_preview": "В поле {field} выбрано {options}",
  "rule_department_caption": "Сотрудники из выбранного отдела",
  "rule_department_manager_approval_caption": "Руководитель отдела сотрудника",
  "rule_department_manager_title": "Руководитель отдела",
  "rule_direct_manager_approval_caption": "Прямой руководитель сотрудника",
  "rule_direct_manager_title": "Руководитель",
  "rule_division_caption": "Сотрудники из выбранного подразделения",
  "rule_employee_caption": "Только выбранные сотрудники",
  "rule_employee_approval_caption": "Сотрудник, к которому применяется маршрут согласования",
  "rule_employees_in_custom_field": "Указанные в выбранных полях",
  "rule_employees_in_custom_field_caption": "Все сотрудники, указанные хотя бы в одном из выбранных полей. Например, все HR-администраторы компании",
  "rule_employees_with_employee_in_custom_field": "С выбранными сотрудниками в полях",
  "rule_employees_with_employee_in_custom_field_caption": "Сотрудники, у которых хотя бы в одном из выбранных полей указан выбранный человек. Например, все сотрудники, у которых HR Admin — Марина",
  "rule_employees_with_me_in_custom_field": "С сотрудником этой роли в полях",
  "rule_employees_with_me_in_custom_field_caption": "Для каждого сотрудника с этой ролью выбираются сотрудники, в чьих карточках он указан в выбранных полях. Например, для каждого HR-администратора — его сотрудники",
  "rule_cf_reference_fields_label": "Поля в карточках сотрудников",
  "rule_cf_reference_fields_placeholder": "Например, HR Admin",
  "rule_cf_reference_employees_label": "Кто должен быть указан в этих полях",
  "rule_cf_reference_role_employee_hint": "В полях ищется сотрудник с этой ролью",
  "rule_cf_reference_preview": "Сотрудники, у которых в полях {fields} указаны {employees}",
  "rule_employment_contract_caption": "Фильтр по типу трудового договора сотрудника",
  "rule_employment_duration_after_date_inclusive": "После даты (включительно)",
  "rule_employment_duration_before_date_inclusive": "До даты (включительно)",
  "rule_employment_duration_by_period": "По периоду",
  "rule_employment_duration_calc_mode": "Считаем",
  "rule_employment_duration_caption": "Как долго сотрудник работает в компании",
  "rule_employment_duration_condition": "Условие по сроку трудоустройства",
  "rule_employment_duration_custom_date": "Кастомная дата",
  "rule_employment_duration_date_condition": "Условие по дате",
  "rule_employment_duration_exclude_greater_or_equal": "Исключить: больше или равно",
  "rule_employment_duration_exclude_less_or_equal": "Исключить: меньше или равно",
  "rule_employment_duration_greater_or_equal": "Больше или равно",
  "rule_employment_duration_include_greater_or_equal": "Включить: больше или равно",
  "rule_employment_duration_include_less_or_equal": "Включить: меньше или равно",
  "rule_employment_duration_less_or_equal": "Меньше или равно",
  "rule_employment_duration_one_month": "1 месяц",
  "rule_employment_duration_one_year": "1 год",
  "rule_employment_duration_period": "Период",
  "rule_employment_duration_period_condition": "Условие по периоду",
  "rule_employment_duration_six_months": "6 месяцев",
  "rule_employment_duration_specific_date": "По конкретной дате",
  "rule_employment_duration_three_months": "3 месяца",
  "rule_employment_type_caption": "Фильтр по типу занятости сотрудника",
  "rule_group_by_affected_employee": "По целевому сотруднику",
  "rule_group_by_attribute": "По данным сотрудника",
  "rule_group_by_role": "Руководители и тимлиды",
  "rule_group_relative": "Относительно сотрудника с ролью",
  "rule_group_scope": "Вся компания",
  "rule_heads_of_departments_caption": "Сотрудники, назначенные руководителями отделов",
  "rule_heads_of_teams_caption": "Сотрудники, назначенные тимлидами команд",
  "rule_legal_entity_caption": "Сотрудники выбранного юридического лица",
  "rule_lifecycle_status_caption": "Например: работает, в отпуске или уволен",
  "rule_gender_caption": "Например: только сотрудницы",
  "rule_location_caption": "Сотрудники из выбранной локации",
  "rule_manager_of_direct_manager_approval_caption": "Руководитель прямого руководителя сотрудника",
  "rule_manager_of_direct_manager_title": "Руководитель руководителя",
  "rule_managers_caption": "Сотрудники, которые указаны руководителями у других сотрудников",
  "rule_my_department_employees": "Отделы, где я состою",
  "rule_my_department_employees_caption": "Сотрудники отделов, в которых состоит сотрудник с этой ролью",
  "rule_my_departments": "Отделы, где я руководитель",
  "rule_my_departments_caption": "Сотрудники отделов, где сотрудник с этой ролью назначен руководителем",
  "rule_my_subordinates": "Мои подчинённые",
  "rule_my_subordinates_caption": "Все подчинённые сотрудника с этой ролью на всех уровнях",
  "rule_my_team": "Команды, где я тимлид",
  "rule_my_team_caption": "Сотрудники команд, где сотрудник с этой ролью назначен тимлидом",
  "rule_myself": "Сам сотрудник",
  "rule_myself_caption": "Только сотрудник, которому назначена эта роль",
  "rule_organization": "Все сотрудники",
  "rule_organization_caption": "Все сотрудники, включая сотрудников со статусом «Уволен»",
  "rule_job_profile_caption": "Сотрудники с выбранным должностным профилем",
  "rule_team_caption": "Сотрудники из выбранной команды",
  "rule_work_pattern_caption": "Фильтр по графику работы сотрудника",
  "salary": "Зарплата",
  "job_salary_range": "Вилка зарплат (до удержаний)",
  "job_track": "Трек должности",
  "job_grade": "Грейд должности",
  "save_as_new_view": "Сохранить как новое представление",
  "save_changes_to_view": "Сохранить изменения в этом представлении",
  "save_columns_only": "Сохранить только сортировку и колонки",
  "save_current_filters_and_columns": "Сохранить текущие фильтры, сортировку и колонки",
  "save_new_view": "Сохранить новое представление",
  "save_view": "Сохранить представление",
  "saved_views_feature_description": "Сохраняйте фильтры, сортировку и колонки, чтобы быстро возвращаться к ним.",
  "saved_views_feature_title": "Сохраняйте представления",
  "saved_views_label": "Сохранённые представления",
  "score_mark_average": "Средний",
  "score_mark_excellent": "Превосходно",
  "score_mark_good": "Хорошо",
  "score_mark_poor": "Ниже среднего",
  "second_scale_options": "Варианты второй шкалы",
  "select_probation_policy": "Выберите политику испытательного срока",
  "select_probation_policy_and_confirm": "Выберите политику и подтвердите дату окончания",
  "send": "Отправить",
  "send_email": "Отправить письмо",
  "send_invitation": "Отправить приглашение",
  "send_invitation_caption": "Отправить письмо-приглашение сотруднику",
  "send_multiple_emails_text": "Подтверждение массовой отправки писем",
  "sender": "Отправитель",
  "server": "Сервер",
  "set_permissions": "Установить разрешения",
  "settings_calendar_holidays_description": "Настройте расписание праздников для каждого места работы",
  "settings_compensation_change_reasons_description": "Настройка причин корректировки окладов",
  "settings_compensation_types_description": "Настройте различные типы бонусов и других дополнительных выплат",
  "settings_departments_description": "Создайте структуру команд и групп вашей компании",
  "settings_disqualification_reasons_description": "Задайте стандартные причины отказа кандидатам",
  "settings_division_description": "Группируйте команды по функциям для лучшей организации",
  "settings_employment_contracts_description": "Управляйте различными типами трудовых соглашений",
  "settings_employment_types_description": "Настройте различные форматы работы в компании",
  "settings_features": "Настройки функций",
  "settings_features_description": "Управляйте доступными функциями в вашей системе",
  "webhooks": "Вебхуки",
  "webhooks_description": "Управляйте вебхуками для внешних интеграций",
  "webhook_active": "Активный endpoint",
  "webhook_active_description": "События доставляются, только пока endpoint активен",
  "webhook_create": "Создать вебхук",
  "webhook_custom_headers": "Пользовательские заголовки",
  "webhook_delete_description": "Endpoint перестанет получать события. Это действие нельзя отменить.",
  "webhook_delete_title": "Удалить вебхук?",
  "webhook_edit": "Редактировать вебхук",
  "webhook_attempt": "Попытка",
  "webhook_delivery_details": "Детали доставки",
  "webhook_delivery_empty_description": "Доставки появятся здесь после получения события этим вебхуком или отправки тестовой доставки",
  "webhook_delivery_history": "История доставок",
  "webhook_delivery_load_error": "Не удалось загрузить историю доставок",
  "webhook_delivery_status_delivered": "Доставлено",
  "webhook_delivery_status_failed": "Ошибка",
  "webhook_delivery_status_pending": "Ожидает",
  "webhook_event": "Событие",
  "webhook_event_approval_request_approved": "Запрос на согласование одобрен",
  "webhook_event_approval_request_canceled": "Запрос на согласование отменён",
  "webhook_event_approval_request_rejected": "Запрос на согласование отклонён",
  "webhook_event_employee_employment_changed": "Занятость сотрудника изменена",
  "webhook_event_employee_compensation_changed": "Компенсация сотрудника изменена",
  "webhook_event_employee_hired": "Сотрудник нанят",
  "webhook_event_employee_notification": "Личное уведомление сотруднику",
  "webhook_event_employee_position_changed": "Должность сотрудника изменена",
  "webhook_event_employee_terminated": "Сотрудник уволен",
  "webhook_event_esign_envelope_completed": "Пакет электронной подписи завершён",
  "webhook_event_job_created": "Вакансия создана",
  "webhook_event_job_deleted": "Вакансия удалена",
  "webhook_event_job_status_changed": "Статус вакансии изменён",
  "webhook_event_job_updated": "Вакансия обновлена",
  "webhook_event_required": "Выберите хотя бы один тип события",
  "webhook_event_survey_completed": "Опрос завершён",
  "webhook_event_task_archived": "Задача архивирована",
  "webhook_event_task_completed": "Задача завершена",
  "webhook_event_time_off_request_approved": "Запрос на отсутствие одобрен",
  "webhook_event_types": "Типы событий",
  "webhook_event_workflow_execution_completed": "Выполнение процесса завершено",
  "webhook_header_duplicate": "Заголовок с таким именем уже существует",
  "webhook_header_edit": "Редактировать заголовок",
  "webhook_header_forbidden": "Этот заголовок управляется системой и не может быть переопределён",
  "webhook_header_invalid": "Введите корректное название HTTP-заголовка",
  "webhook_header_name": "Название заголовка",
  "webhook_header_value": "Значение заголовка",
  "webhook_header_value_invalid": "Значение заголовка не может содержать переносы строк",
  "webhook_http_code": "HTTP-код",
  "webhook_load_error": "Не удалось загрузить вебхуки",
  "webhook_load_error_description": "Проверьте соединение и попробуйте снова.",
  "webhook_operation_error": "Не удалось выполнить операцию. Попробуйте снова.",
  "webhook_redeliver": "Повторить доставку",
  "webhook_redelivery_failed": "Повторная доставка завершилась ошибкой",
  "webhook_redelivery_succeeded": "Повторная доставка выполнена",
  "webhook_response": "Ответ",
  "webhook_rotate_secret": "Обновить secret",
  "webhook_rotate_secret_description": "Текущий secret сразу перестанет работать. Новый secret будет показан только один раз.",
  "webhook_secret": "Secret для подписи",
  "webhook_secret_description": "Скопируйте и сохраните secret сейчас. В целях безопасности он больше не будет показан.",
  "webhook_secret_title": "Сохраните secret для подписи",
  "webhook_status_inactive": "Неактивен",
  "webhook_test_delivery": "Тестовая доставка",
  "webhook_test_failed": "Тестовая доставка завершилась ошибкой",
  "webhook_test_succeeded": "Тестовая доставка выполнена",
  "webhook_url_invalid": "Введите корректный URL",
  "service_users_description": "Создание и управление сервисными пользователями",
  "settings_import_data": "Импорт данных",
  "settings_import_data_description": "Массовое добавление или обновление данных из файлов",
  "settings_job_archiving_reasons_description": "Настройка причин архивирования вакансий",
  "settings_legal_entities_description": "Управляйте юридической структурой компании",
  "settings_locations_description": "Управляйте настройками офисов и удаленной работы",
  "settings_organization_description": "Настройте основные параметры вашей компании",
  "settings_organization_links_description": "Управление ссылками для сотрудников",
  "settings_pipelines_description": "Создайте этапы и процесс найма",
  "settings_job_profiles_description": "Управляйте должностными профилями, ролями, уровнями, треками и грейдами",
  "settings_probation_policies_description": "Определите и управляйте правилами испытательных сроков сотрудников",
  "settings_roles_and_permissions_description": "Управляйте доступом к системе",
  "settings_security_description": "Управление сложностью пароля, двухфакторной аутентификацией и другими параметрами",
  "settings_security_title": "Настройки безопасности",
  "settings_account_label": "Аккаунт",
  "settings_account_manage": "Управление",
  "settings_general_description": "Управление организацией и функциями",
  "settings_analytics_title": "Аналитика и отчётность",
  "settings_analytics_description": "Настройте, как рассчитываются кадровые метрики и отчёты для вашей организации",
  "settings_metrics_configuration_caption": "Настройте, как рассчитываются метрики вашей организации",
  "settings_metrics_configuration_retention_title": "Метрики удержания",
  "settings_metrics_configuration_retention_caption": "Эти настройки влияют на то, как данные об удержании, оттоке и внутренней мобильности отображаются в дашбордах",
  "settings_company_structure_title": "Структура компании",
  "settings_company_structure_description": "Подразделения, должности, локации",
  "settings_policies_title": "Политики",
  "settings_policies_description": "Отпуска, согласования, праздники",
  "settings_employment_title": "Трудоустройство",
  "settings_employment_description": "Договоры, компенсации, увольнение",
  "settings_employee_profile_title": "Профиль сотрудника",
  "settings_recruitment": "Рекрутинг",
  "settings_recruitment_directories_title": "Справочники рекрутинга",
  "settings_recruitment_directories_description": "Теги, источники, причины отказа и закрытия вакансий",
  "settings_platform": "Платформа",
  "settings_personal_account_title": "Управление аккаунтом",
  "settings_personal_account_caption": "В настройках аккаунта",
  "settings_personal_info_title": "Личная информация",
  "settings_personal_info_caption": "В вашем профиле",
  "settings_hiring_flows_description": "Управляйте созданием новых сотрудников",
  "settings_sources_description": "Отслеживайте источники кандидатов",
  "settings_tags_description": "Отмечайте навыки и квалификации кандидатов",
  "settings_templates_description": "Создайте стандартные сообщения",
  "settings_termination_leave_types_description": "Установите стандартные типы увольнения",
  "settings_termination_reasons_description": "Установите стандартные причины прекращения работы",
  "settings_work_patterns_description": "Настройте стандартные графики работы и недельные нормы часов",
  "show_full_salary": "Показывать полную зарплату",
  "show_full_salary_description": "Показывать полные суммы зарплаты там, где доступны данные о компенсации",
  "sign_up_accept_invitation_agree": "Принимая приглашение, вы соглашаетесь с",
  "state": "Штат",
  "step_of": "Шаг {currentStep} из {countSteps}",
  "structure": "Структура",
  "successfully_created_profile": "Вы успешно создали профиль для {employee_name}",
  "talent": "Развитие",
  "team": "Команда",
  "team_lead": "Тимлид",
  "team_leads": "Тимлиды команд",
  "team_profile": "Профиль команды",
  "teams": "Команды",
  "terminate_employee": "Уволить сотрудника",
  "terminate_employee_menu_caption": "Оформить увольнение сотрудника",
  "termination": "Увольнение",
  "termination_comment": "Комментарий к увольнению",
  "termination_date": "Дата увольнения",
  "to_everyone": "Всем",
  "termination_history_update_required": "Сначала нужно обновить историю сотрудника, чтобы редактировать или удалить эту запись увольнения.",
  "termination_leave_types": "Типы ухода",
  "termination_reason": "Причина уволнения",
  "termination_reason_delete_confirm": "Вы хотите удалить причину?",
  "termination_reasons": "Причины увольнения",
  "time_off_balances": "Балансы отсутствий",
  "to_up": "Вверх",
  "total": "Всего",
  "turn_off": "Выключить",
  "two_factor": "Двухфакторная аутентификация",
  "two_factor_cant_scan_qr": "Не удаётся отсканировать QR-код?",
  "two_factor_disable": "Отключить двухфакторную аутентификацию",
  "two_factor_disable_caption": "Ваш аккаунт станет менее защищённым.",
  "two_factor_enabled": "Двухфакторная аутентификация включена",
  "two_factor_enter_code": "Введите код подтверждения",
  "two_factor_from_authenticator": "Из приложения-аутентификатора",
  "two_factor_scan_qr": "Отсканируйте QR-код в Google Authenticator или другом совместимом приложении",
  "two_factor_setup": "Настройка двухфакторной аутентификации",
  "two_factor_setup_authenticator_app": "Настройка приложения-аутентификатора",
  "two_factor_setup_warning_logout_20_min": "Без двухфакторной аутентификации вы будете разлогинены через 20 минут",
  "unlimited": "Без ограничений",
  "upcoming_birthdays": "Предстоящие дни рождения",
  "update_role_from_settings_caption": "Все настройки выбранных ролей будут перезаписаны",
  "update_role_from_settings_title": "Обновить существующие роли",
  "update_settings_in_x_roles": "Обновить настройки в {in_count_roles}",
  "update_view": "Обновить «{title}»",
  "upload_photo": "Загрузить фото",
  "upload_photo_caption": "Загрузить или изменить фото профиля сотрудника",
  "use_ssl": "Использовать SSL",
  "view_filters_count": "{count, plural, =0 {Без фильтров} one {# фильтр} few {# фильтра} many {# фильтров} other {# фильтров}}",
  "view_name": "Название представления",
  "view_on_calendar": "Посмотреть в календаре",
  "view_profile": "Посмотреть профиль",
  "view_recipient_profile": "Посмотреть профиль получателя",
  "view_sender_profile": "Посмотреть профиль отправителя",
  "visibility_managed_by_organization": "Видимость регулируется настройками организации",
  "want_less_security": "Меньше безопасности",
  "warning_cant_undo": "Это действие нельзя будет отменить",
  "welcome_after_email_confirm_description": "Мы рады приветствовать вас в %APP_NAME%, лучшем инструменте для упрощения процесса найма",
  "welcome_after_email_confirm_install_chrome": "Установите наше расширение для Chrome",
  "welcome_after_email_confirm_install_chrome_button": "Установить расширение Chrome",
  "welcome_after_email_confirm_install_chrome_description": "Улучшите процесс найма с помощью нашего расширения для Google Chrome, разработанного для того, чтобы помочь вам легко добавлять кандидатов, просматривая веб-страницы",
  "welcome_after_email_confirm_invite_your_team": "Пригласите свою команду",
  "welcome_after_email_confirm_invite_your_team_button": "Пригласить членов команды",
  "welcome_after_email_confirm_invite_your_team_description": "Легко взаимодействуйте, пригласив своих коллег присоединиться к %APP_NAME%",
  "welcome_after_email_confirm_title": "Спасибо за подтверждение вашей электронной почты!",
  "welcome_after_email_confirm_title_2": "Добро пожаловать в %APP_NAME%!",
  "welcome_after_email_confirm_whats_next": "Что дальше?",
  "welcome_to_platform": "Добро пожаловать в %APP_NAME%!",
  "work_email": "Рабочая электронная почта",
  "work_email_copied": "Рабочая электронная почта скопирована",
  "work_info": "Работа",
  "work_pattern": "График работы",
  "work_patterns": "Графики работы",
  "working_days": "Рабочие дни",
  "your_team_growing": "Давайте добавим информацию",
  "your_teammate_birthday_today": "У вашего коллеги сегодня день рождения!",
  "zip": "Индекс",
  "~": "~",
  "no_folders_created": "Папок пока нет",
  "document_folders": "Папки документов",
  "settings_documents_description": "Управляйте папками для хранения документов",
  "permissions_manage_documents_description": "Управлять папками для хранения документов",
  "employee_documents": "Папки сотрудника",
  "organization_documents": "Документы компании",
  "view_documents_rules": "Кому видна",
  "view_documents_rules_caption": "Определите, кто сможет видеть эту папку и её документы.",
  "edit_documents_rules": "Кто управляет",
  "edit_documents_rules_caption": "Определите, кто сможет добавлять, редактировать и удалять документы в папке. Редакторы автоматически видят папку.",
  "employee_folder_permissions_none_description": "Папка скрыта от сотрудника",
  "employee_folder_permissions_view_description": "Сотрудник может видеть документы",
  "employee_folder_permissions_edit_description": "Сотрудник может видеть и управлять документами",
  "employee_workflow_permissions_run_title": "Запуск процессов",
  "employee_workflow_permissions_run_description": "Какие процессы роль может запустить на сотрудника, к данным которого у неё есть доступ",
  "employee_workflow_permissions_run_edit_title": "Может запускать",
  "employee_workflow_permissions_executions_title": "Запущенные процессы",
  "employee_workflow_permissions_executions_description": "Запуски процессов по сотрудникам, к данным которых у роли есть доступ",
  "employee_workflow_permissions_executions_view_title": "Смотреть",
  "employee_workflow_permissions_executions_edit_title": "Смотреть и отменять",
  "employee_workflow_permissions_executions_none_description": "Сотрудник не видит запуски процесса",
  "employee_workflow_permissions_executions_view_description": "Сотрудник может смотреть запуски процесса",
  "employee_workflow_permissions_executions_edit_description": "Сотрудник может смотреть и отменять запуски процесса",
  "folder_roles_modal_setup_field_permissions": "Настройка прав доступа к папке",
  "folder_roles_modal_new_field_ready": "Отлично! Новая папка создана!",
  "folder_roles_modal_new_field_created": "Новая папка создана",
  "folder_roles_modal_lets_choose": "Приступим к настройкам",
  "folder_roles_modal_who_should_see": "Кто должен видеть эту папку?",
  "folder_roles_modal_set_access": "Назначьте доступ для каждой роли в вашем рабочем пространстве:",
  "folder_roles_modal_who_can_configure": "Эти коллеги могут настраивать доступ:",
  "folder_roles_modal_apply_access": "Применить правила",
  "folder_roles_modal_manage_roles": "Управлять в настройках рабочего пространства",
  "folder_roles_modal_new_field_is_hidden": "Эта новая папка сейчас скрыта",
  "folder_roles_modal_new_field_is_hidden_information": "Никто, включая вас, не сможет видеть или использовать её, пока доступ не будет предоставлен в разрешениях ролей. У вас нет прав, чтобы сделать её видимой или разрешить управление документами.",
  "folder_roles_modal_need_help_question": "Нужна помощь с дальнейшей настройкой?",
  "folder_roles_modal_ok_got_it": "Хорошо",
  "turn_on_reminders": "Включить напоминания",
  "notifications_and_reminders": "Уведомления и напоминания",
  "notifications_and_reminders_description": "Настройте способы вовлечения",
  "reminder_channels_description": "Выберите, куда отправлять уведомления и напоминания",
  "choose_reminder_frequency": "Выберите частоту напоминаний",
  "reminder_mode_gentle": "Лёгкий",
  "reminder_mode_gentle_description": "Несколько напоминаний ближе к дедлайну",
  "reminder_mode_balanced": "Сбалансированный",
  "reminder_mode_balanced_description": "Регулярные напоминания на протяжении всего периода",
  "reminder_mode_persistent": "Активный",
  "reminder_mode_persistent_description": "Частые напоминания с дополнительными ближе к дедлайну",
  "reminder_mode_custom": "Настраиваемый",
  "reminder_mode_custom_description": "Установите собственный интервал напоминаний",
  "reminder_count_info": "До {reminders} за {days}",
  "reminder_mode": "{level} режим",
  "remind_every_masculine": "{count, plural, one{Напоминать каждый} few{Напоминать каждые} many{Напоминать каждые} other{Напоминать каждые}}",
  "remind_every_feminine": "{count, plural, one{Напоминать каждую} few{Напоминать каждые} many{Напоминать каждые} other{Напоминать каждые}}",
  "reminder_period_day": "{count, plural, one{день} few{дня} many{дней} other{дня}}",
  "reminder_period_week": "{count, plural, one{неделю} few{недели} many{недель} other{недели}}",
  "reminder_period_month": "{count, plural, one{месяц} few{месяца} many{месяцев} other{месяца}}",
  "reminder_requires": "Для умных напоминаний требуется {needed}",
  "reminder_requires_due_date": "установить день завершения",
  "reminder_requires_due_date_days": "срок выполнения",
  "reminder_requires_period": "установить период ревью",
  "reminder_requires_period_description": "Добавьте даты начала и завершения, чтобы включить умные напоминания",
  "reminder_requires_future_date": "дата завершения в будущем",
  "reminder_requires_future_date_description": "Установите дату завершения больше текущей, чтобы включить умные напоминания",
  "external_channels": "Внешние каналы",
  "no_employee_folders_description": "Добавьте папку в каждый профиль. \nЗагружайте файлы для каждого сотрудника.",
  "no_org_folders_description": "Создайте папки для всей компании. \nЗагружайте файлы, которые увидят все.",
  "career_architecture": "Карьерная архитектура",
  "manage_framework": "Управление фреймворком",
  "create_job_role": "Создать роль",
  "edit_job_role": "Редактировать роль",
  "delete_job_role_title": "Удалить роль",
  "delete_role": "Удалить роль",
  "delete_job_role_description": "Вы уверены, что хотите удалить эту роль? Это действие нельзя отменить",
  "grade": "Грейд",
  "grades": "Грейды",
  "track": "Трек",
  "tracks": "Треки",
  "manage_grade_scale": "Управление шкалой грейдов",
  "manage_job_tracks": "Управление треками",
  "setup_grade_names_for_each_track": "Настройка названий грейдов для каждого трека",
  "career_framework_empty_description": "Добавьте грейды и треки для построения карьерного фреймворка",
  "job_catalog_tracks": "Треки должностей",
  "job_catalog_grades": "Грейды должностей",
  "job_track_archived": "Трек заархивирован",
  "job_grade_archived": "Грейд заархивирован",
  "job_track_and_grade_archived": "Трек и грейд заархивированы",
  "job_level_archived": "Уровень заархивирован",
  "create_job_level": "Создать уровень",
  "edit_job_level": "Редактировать уровень",
  "delete_job_level_title": "Удалить уровень",
  "delete_job_level_description": "Вы уверены, что хотите удалить этот уровень? Это действие нельзя отменить",
  "edit_levels": "Редактирование уровней",
  "used_by": "Использование: {target}",
  "job_profiles": "Должностные профили",
  "edit_job_profiles": "Редактирование должностных профилей",
  "job_profile": "Должностной профиль",
  "job_profile_employees_empty": "Этот профиль не используется сотрудниками",
  "job_profile_employees_load_error": "Не удалось загрузить сотрудников",
  "job_profile_for_role": "{title} для {role}",
  "display_name": "Отображаемое название",
  "original_name_hint": "Оригинальное название: {name}",
  "reset_to_original": "Сбросить к оригиналу",
  "salary_min": "Мин. до удержаний",
  "salary_max": "Макс. до удержаний",
  "fte": "Ставка",
  "standard_weekly_hours": "Норма часов в неделю",
  "standard_weekly_hours_hint": "Используется как знаменатель при расчёте ставки (FTE).",
  "standard_weekly_hours_inherit_org": "Оставьте пустым, чтобы наследовать от организации.",
  "standard_weekly_hours_inherit_legal_entity": "Оставьте пустым, чтобы наследовать от юрлица сотрудника.",
  "job_profile_description": "Описание должностного профиля",
  "job_profile_description_hint": "Отображается в подсказках должностных профилей",
  "move_job_profile": "Перенести",
  "move_job_profile_to_another_role": "Перенести в другую роль",
  "move_job_profile_to_another_level": "Перенести на другой уровень",
  "job_profile_moved_to_role": "Должностной профиль перенесён в роль {role}",
  "job_profile_moved_to_level": "Должностной профиль перенесён на уровень {level}",
  "confirm_job_profile_replacement": "Подтвердите замену",
  "job_profile_replacement_confirmation": "Должностной профиль для <strong>{level}</strong> уже существует в роли {role}. Заменить его копией текущего профиля?",
  "replace_job_position": "Заменить должностной профиль",
  "new_job_position_created": "Новый должностной профиль создан в роли {role}",
  "job_role": "Роль",
  "job_roles": "Роли",
  "job_level": "Уровень",
  "reassign_before_deleting": "Переназначьте их перед удалением",
  "employee_position_change_reasons": "Причины изменения должности",
  "employee_position_change_reason": "Причина изменения должности",
  "settings_employee_position_change_reasons_description": "Настройте причины изменения должности сотрудника",
  "column_filter_is_empty": "Пусто",
  "column_filter_is_filled": "Заполнено",
  "add_or_search_filter": "Добавить или найти фильтр",
  "edit_filters": "Изменить фильтры",
  "your_filters": "Ваши фильтры",
  "column_filter_contains": "Содержит",
  "column_filter_in_range": "В диапазоне",
  "column_filter_in_period": "За период",
  "column_filter_any_of": "Любой из",
  "column_filter_range_invalid": "«От» больше, чем «До»",
  "column_filter_text_placeholder": "Часть значения",
  "rule_group_by_candidate_job": "По вакансии",
  "rule_candidate_job_recruiters": "Рекрутёры вакансии",
  "rule_candidate_job_recruiters_caption": "Рекрутёры вакансии кандидата",
  "rule_candidate_job_stakeholders": "Стейкхолдеры вакансии",
  "rule_candidate_job_stakeholders_caption": "Стейкхолдеры вакансии кандидата",
  "rule_group_base_active": "Считаем только активных сотрудников",
  "rule_group_hidden_rules_note": "Подсчёт учитывает дополнительные ограничения.",
  "rule_group_preview_error": "Не удалось загрузить количество сотрудников.",
  "rule_group_role_preview_note": "Охват рассчитан относительно сотрудников с этой ролью.",
  "rule_group_visible_only": "В просмотре показаны только сотрудники, к которым у вас есть доступ."
}
